import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';

export class OnboardingJurisdictionViewedEventTracking extends SelfServeSignupPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_JURISDICTION_VIEWED;
}
